import { Star } from '../entities/Star';
import { Dungeon } from '../dungeon/Dungeon';
import { Vec3 } from '../types';

export class DebugOverlay {
  private element: HTMLDivElement;

  constructor() {
    this.element = document.createElement('div');
    this.element.id = 'debug-overlay';
    this.element.style.position = 'absolute';
    this.element.style.bottom = '10px';
    this.element.style.right = '10px';
    this.element.style.color = '#0f0';
    this.element.style.fontFamily = 'monospace';
    this.element.style.fontSize = '14px';
    this.element.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
    this.element.style.padding = '10px';
    this.element.style.borderRadius = '4px';
    this.element.style.pointerEvents = 'none';

    document.body.appendChild(this.element);
  }

  update(playerPos: Vec3, playerYaw: number, stars: Star[], dungeon?: Dungeon): void {
    // Find nearest uncollected star
    let nearestStar: Star | null = null;
    let nearestDistance = Infinity;

    for (const star of stars) {
      if (star.collected) continue;

      const dx = star.position.x - playerPos.x;
      const dz = star.position.z - playerPos.z;
      const distance = Math.sqrt(dx * dx + dz * dz);

      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestStar = star;
      }
    }

    let html = '';

    // Show cell position
    if (dungeon) {
      const cell = dungeon.worldToCell(playerPos.x, playerPos.z);
      html += `<div>Cell: (${cell.x}, ${cell.z})</div>`;
    }

    if (nearestStar) {
      const dx = nearestStar.position.x - playerPos.x;
      const dz = nearestStar.position.z - playerPos.z;

      // Calculate angle from player to star in world space
      // atan2(dx, -dz) gives angle where 0 = north (-Z), positive = clockwise
      const angleToStar = Math.atan2(dx, -dz);

      // Calculate relative angle (how far the star is from where player is facing)
      let relativeAngle = angleToStar - playerYaw;

      // Normalize to [-PI, PI]
      while (relativeAngle > Math.PI) relativeAngle -= 2 * Math.PI;
      while (relativeAngle < -Math.PI) relativeAngle += 2 * Math.PI;

      // Convert to degrees for display
      const angleDegrees = (relativeAngle * 180 / Math.PI).toFixed(1);

      html += `
        <div>Distance: ${nearestDistance.toFixed(2)}</div>
        <div>Angle: ${angleDegrees}&deg;</div>
      `;
    } else {
      html += '<div>No stars remaining</div>';
    }

    this.element.innerHTML = html;
  }

  show(): void {
    this.element.style.display = 'block';
  }

  hide(): void {
    this.element.style.display = 'none';
  }

  destroy(): void {
    this.element.remove();
  }
}
